<template>
	<div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><a href="/">分类管理</a></el-breadcrumb-item>
			<el-breadcrumb-item>分类列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card>
			<el-table :data="DingdanList" border stripe>
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="username" label="姓名"></el-table-column>
				<el-table-column prop="tel" label="电话"></el-table-column>
				<el-table-column prop="weixin" label="微信"></el-table-column>
				<el-table-column prop="qq" label="自我优势介绍"></el-table-column>
				<el-table-column prop="school" label="学校"></el-table-column>
				<el-table-column prop="xueli" label="学历"></el-table-column>
				<el-table-column prop="shenfen" label="身份"></el-table-column>
				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>

					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[2, 4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>


	</div>
</template>

<script>
	import {
		DingdanList,
		Dingdandel
	} from '@/api/index.js'
	export default {
		data() {
			return {
				DingdanList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
			}
		},
		created() {
			this.getDingdanList();
		},
		methods: {
			async getDingdanList() {
				const {
					data: res
				} = await DingdanList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});

				this.DingdanList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			handleSizeChange(newsize) {
				this.pageSize = newsize;
				this.getDingdanList();
			},
			handleCurrentChange(newnum) {
				this.pageNum = newnum;
				this.getDingdanList();
			},
			async del(id) {
				const {
					data: res
				} = await Dingdandel({
					id
				});
				if (res.code == 200) {
					this.$message.success('删除成功');
					this.getDingdanList();
				} else {
					this.$message.success('删除失败');
				}
			},
		}
	}
</script>
<style scoped>
	.el-card {
		margin-top: 20px;
	}

	.el-row {
		margin-bottom: 20px;
	}
</style>